// extracted by mini-css-extract-plugin
export default {"btn":"CustomVideoBtn_btn__qDDah","wrapper":"CustomVideoBtn_wrapper__hSPea","modalVideo":"CustomVideoBtn_modalVideo__JbQbB"};